 // ACFT Calculator - Sistem Baru dengan Data JSON (5 Events)
  // Menangani nilai null dan slider yang hanya menggunakan nilai valid

  class ACFTCalculator {
    constructor() {
      this.data = {
        mdl: [],
        hrp: [], // Hand Release Push-up
        sdc: [], // Sprint Drag Carry - menggunakan data scp.json
        plk: [], // Plank
        run: [], // 2-Mile Run - menggunakan data 2mr.json
        alternateRuns: []
      };

      this.currentValues = {
        gender: 'combat',
        age: '17',
        MDL: 80,
        SPT: 2.3, // Tetap ada di HTML tapi tidak dihitung
        HRP: 4,
        SDC: { min: 0, sec: 0 },
        PLK: { min: 0, sec: 0 },
        '2MR': { min: 0, sec: 0 },
        useAlternateRun: false,
        selectedAlternateEvent: null
      };

      this.scores = {
        MDL: 0,
        HRP: 0,
        SDC: 0,
        PLK: 0,
        '2MR': 0
        // SPT tidak ada dalam scores
      };

      this.isUpdatingFromInput = false;

      this.init();
    }

    async init() {
      console.log('Starting ACFT Calculator initialization (5 Events)...');

      try {
        await this.loadAllData();
        await this.waitForDOM();
        this.setupSliders();
        this.setupEventListeners();
        this.toggleAlternateRunInputs(this.currentValues.useAlternateRun);
        this.updateAllScores();
        console.log('ACFT Calculator initialized');
      } catch (error) {
        console.error('Error initializing ACFT Calculator:', error);
      }
    }

    async loadAllData() {
      try {
        const [mdlData, hrpData, sdcData, plkData, runData, alternateRunsData] = await Promise.all([
          fetch('//www.grittysoldier.com/cdn/shop/t/22/assets/mdl.json?v=57700738727256407921764009141').then(r => r.json()),
          fetch('//www.grittysoldier.com/cdn/shop/t/22/assets/hrp.json?v=167506315292374920121764075519').then(r => r.json()),
          fetch('//www.grittysoldier.com/cdn/shop/t/22/assets/scp.json?v=16903320527772459181763650900').then(r => r.json()), // SDC menggunakan scp.json
          fetch('//www.grittysoldier.com/cdn/shop/t/22/assets/plk.json?v=124767685047104728501763650900').then(r => r.json()),
          fetch('//www.grittysoldier.com/cdn/shop/t/22/assets/2mr.json?v=172865423624819151241764065051').then(r => r.json()),
          fetch('//www.grittysoldier.com/cdn/shop/t/22/assets/alternate.json?v=3935858691235538341763650900').then(r => r.json())
        ]);

        this.data.mdl = mdlData;
        this.data.hrp = hrpData;
        this.data.sdc = sdcData;
        this.data.plk = plkData;
        this.data.run = runData;
        this.data.alternateRuns = alternateRunsData;

        console.log('All data loaded (5 events)');
      } catch (error) {
        console.error('Error loading data:', error);
        throw error;
      }
    }

    waitForDOM() {
      return new Promise((resolve) => {
        const checkDOM = () => {
          const requiredElements = [
            'select[name="gender"]',
            'select[name="age"]',
            'input[name="MDL"]',
            '[data-field-id="MDL"] .slider'
          ];

          const allExists = requiredElements.every(selector =>
            document.querySelector(selector) !== null
          );

          if (allExists) {
            resolve();
          } else {
            setTimeout(checkDOM, 100);
          }
        };
        checkDOM();
      });
    }

    getAgeGroupKey(ageValue) {
      const ageMap = {
        '17': '17-21',
        '22': '22-26',
        '27': '27-31',
        '32': '32-36',
        '37': '37-41',
        '42': '42-46',
        '47': '47-51',
        '52': '52-56',
        '57': '57-61',
        '62': 'Over 62'
      };
      return ageMap[ageValue] || '17-21';
    }

    getGenderKey(genderValue) {
      if (genderValue === 'male' || genderValue === 'combat') {
        return 'M';
      } else if (genderValue === 'female') {
        return 'F';
      }
      return 'M';
    }

    // Konversi waktu dari menit:detik ke total detik
    timeToSeconds(timeStr) {
      if (typeof timeStr === 'string' && timeStr.includes(':')) {
        const [min, sec] = timeStr.split(':').map(Number);
        return min * 60 + sec;
      }
      return 0;
    }

    // Mendapatkan nilai-nilai valid dari data untuk slider (menghindari null)
    getValidValuesForSlider(data, ageGroup, gender) {
      const genderKey = this.getGenderKey(gender);
      const validValues = [];

      data.forEach(item => {
        const ageData = item[ageGroup];
        if (ageData && ageData[genderKey] !== null && ageData[genderKey] !== undefined) {
          let value = ageData[genderKey];

          // Convert to number if possible (for MDL, HRP, etc.)
          if (typeof value === 'string' && value.includes(':')) {
            value = this.timeToSeconds(value);
          } else {
            value = Number(value);
          }

          if (!isNaN(value)) {
            validValues.push({
              value: value,
              points: item.Points
            });
          }
        }
      });

      // Urutkan berdasarkan nilai
      validValues.sort((a, b) => a.value - b.value);

      // Hapus duplikat nilai
      const uniqueValues = [];
      const seenValues = new Set();

      validValues.forEach(item => {
        if (!seenValues.has(item.value)) {
          seenValues.add(item.value);
          uniqueValues.push(item);
        }
      });

      return uniqueValues;
    }

  calculateMDLPoints(value, gender, age) {
    const genderKey = this.getGenderKey(gender);
    const ageGroupKey = this.getAgeGroupKey(age);
    
    // Ensure value is a number
    const numValue = Number(value);
    
    if (isNaN(numValue)) {
      console.warn(`MDL: Invalid value ${value}`);
      return 0;
    }

    // Get all valid data entries for this age/gender
    const validData = this.data.mdl.filter(item => {
      const ageData = item[ageGroupKey];
      return ageData && ageData[genderKey] !== null && ageData[genderKey] !== undefined;
    });

    if (validData.length === 0) {
      console.warn(`MDL: No valid data for ${ageGroupKey}/${genderKey}`);
      return 0;
    }

    // Sort from highest requirement to lowest (for threshold-based: value >= requirement)
    // This ensures we find the highest threshold the value meets
    validData.sort((a, b) => {
      const aVal = Number(a[ageGroupKey][genderKey]);
      const bVal = Number(b[ageGroupKey][genderKey]);
      return bVal - aVal; // Descending order
    });

    // Find the highest threshold that the value meets or exceeds
    for (let entry of validData) {
      const requirement = Number(entry[ageGroupKey][genderKey]);
      // Use >= comparison: if value meets or exceeds requirement, get those points
      // Example: if 20 = 10 points and 25 = 15 points, then 21-24 also get 10 points
      if (numValue >= requirement) {
        const points = entry.Points;
        console.log(`MDL: Value ${numValue} (${ageGroupKey}/${genderKey}) >= ${requirement} = ${points} points`);
        return points;
      }
    }
    
    // If value doesn't meet any requirement, return 0
    console.warn(`MDL: Value ${numValue} (${ageGroupKey}/${genderKey}) does not meet any requirement`);
    return 0;
  }

    // Hitung points untuk HRP
    calculateHRPPoints(value, gender, age) {
      const genderKey = this.getGenderKey(gender);
      const ageGroupKey = this.getAgeGroupKey(age);
      
      // Ensure value is a number and handle precision
      const numValue = Number(value);
      
      if (isNaN(numValue)) {
        console.warn(`HRP: Invalid value ${value}`);
        return 0;
      }

      const validData = this.data.hrp.filter(item => {
        const ageData = item[ageGroupKey];
        return ageData && ageData[genderKey] !== null && ageData[genderKey] !== undefined;
      });

      if (validData.length === 0) {
        console.warn(`HRP: No valid data for ${ageGroupKey}/${genderKey}`);
        return 0;
      }

      // Urutkan dari nilai terbesar ke terkecil untuk HRP
      validData.sort((a, b) => {
        const aVal = Number(a[ageGroupKey][genderKey]);
        const bVal = Number(b[ageGroupKey][genderKey]);
        return bVal - aVal;
      });

      for (let entry of validData) {
        const requirement = Number(entry[ageGroupKey][genderKey]);
        // Use >= comparison with proper number comparison
        if (numValue >= requirement) {
          const points = entry.Points;
          console.log(`HRP: Value ${numValue} (${ageGroupKey}/${genderKey}) >= ${requirement} = ${points} points`);
          return points;
        }
      }
      
      console.warn(`HRP: Value ${numValue} (${ageGroupKey}/${genderKey}) does not meet any requirement`);
      return 0;
    }

    // Hitung points untuk SDC (Sprint Drag Carry)
    calculateSDCPoints(totalSeconds, gender, age) {
      const genderKey = this.getGenderKey(gender);
      const ageGroupKey = this.getAgeGroupKey(age);

      const validData = this.data.sdc.filter(item => {
        const ageData = item[ageGroupKey];
        return ageData && ageData[genderKey] !== null && ageData[genderKey] !== undefined;
      });

      if (validData.length === 0) return 0;

      // Urutkan dari nilai terkecil ke terbesar untuk SDC (waktu)
      validData.sort((a, b) => {
        const aTime = this.timeToSeconds(a[ageGroupKey][genderKey]);
        const bTime = this.timeToSeconds(b[ageGroupKey][genderKey]);
        return aTime - bTime;
      });

      for (let entry of validData) {
        const requirement = entry[ageGroupKey][genderKey];
        const reqSeconds = this.timeToSeconds(requirement);
        // Untuk SDC, waktu lebih kecil = lebih baik
        if (totalSeconds <= reqSeconds) {
          return entry.Points;
        }
      }
      return 0;
    }

    // Hitung points untuk PLK (Plank)
    calculatePLKPoints(totalSeconds, gender, age) {
      const genderKey = this.getGenderKey(gender);
      const ageGroupKey = this.getAgeGroupKey(age);

      const validData = this.data.plk.filter(item => {
        const ageData = item[ageGroupKey];
        return ageData && ageData[genderKey] !== null && ageData[genderKey] !== undefined;
      });

      if (validData.length === 0) return 0;

      // Urutkan dari nilai terbesar ke terkecil untuk PLK
      validData.sort((a, b) => {
        const aTime = this.timeToSeconds(a[ageGroupKey][genderKey]);
        const bTime = this.timeToSeconds(b[ageGroupKey][genderKey]);
        return bTime - aTime;
      });

      for (let entry of validData) {
        const requirement = entry[ageGroupKey][genderKey];
        const reqSeconds = this.timeToSeconds(requirement);
        if (totalSeconds >= reqSeconds) {
          return entry.Points;
        }
      }
      return 0;
    }

    // Hitung points untuk 2MR (2-Mile Run)
    calculate2MRPoints(totalSeconds, gender, age) {
      const genderKey = this.getGenderKey(gender);
      const ageGroupKey = this.getAgeGroupKey(age);

      const validData = this.data.run.filter(item => {
        const ageData = item[ageGroupKey];
        return ageData && ageData[genderKey] !== null && ageData[genderKey] !== undefined;
      });

      if (validData.length === 0) return 0;

      // Sort from FASTEST to SLOWEST (smallest to largest time)
      // For threshold-based scoring: find the range the user's time falls into
      validData.sort((a, b) => {
        const aTime = this.timeToSeconds(a[ageGroupKey][genderKey]);
        const bTime = this.timeToSeconds(b[ageGroupKey][genderKey]);
        return aTime - bTime; // Ascending order (fastest time first)
      });

      // Find the threshold range: user's time should be >= current threshold AND < next threshold
      // If user runs 18:37 and thresholds are 18:00 (100), 18:30 (96), 19:00 (90):
      // - 18:37 >= 18:00? Yes, but check if there's a better threshold
      // - 18:37 >= 18:30? Yes, and 18:37 < 19:00? Yes → Return 96 points ✓
      for (let i = 0; i < validData.length; i++) {
        const entry = validData[i];
        const requirement = entry[ageGroupKey][genderKey];
        const reqSeconds = this.timeToSeconds(requirement);
        
        // Check if user's time >= this threshold
        if (totalSeconds >= reqSeconds) {
          // Check if there's a next threshold that user's time is still >=
          // If yes, continue to find the best threshold
          if (i < validData.length - 1) {
            const nextEntry = validData[i + 1];
            const nextReqSeconds = this.timeToSeconds(nextEntry[ageGroupKey][genderKey]);
            if (totalSeconds >= nextReqSeconds) {
              // User's time is >= next threshold too, so continue
              continue;
            }
          }
          // This is the best threshold the user meets
          const points = entry.Points;
          console.log(`2MR: Time ${totalSeconds}s (${Math.floor(totalSeconds/60)}:${String(totalSeconds%60).padStart(2, '0')}) (${ageGroupKey}/${genderKey}) in range >= ${reqSeconds}s (${requirement}) = ${points} points`);
          return points;
        }
      }
      
      // If user's time doesn't meet any threshold, return 0
      console.warn(`2MR: Time ${totalSeconds}s (${ageGroupKey}/${genderKey}) does not meet any requirement`);
      return 0;
    }

    calculateAlternateRunPoints(totalSeconds, gender, age, alternateEventName) {
      if (!alternateEventName || !this.data.alternateRuns || this.data.alternateRuns.length === 0) return 0;

      const genderKey = this.getGenderKey(gender);
      const ageKey = this.getAgeGroupKey(age);
      const ageGroup  = this.data.alternateRuns.find(e => e.age_group === ageKey);
      const eventData = ageGroup.exercises[alternateEventName];
      if (!eventData || eventData[genderKey] === null) {
        console.warn(`No Go/No-Go standard found for ${alternateEventName}, Age: ${ageKey}, Gender: ${genderKey}`);
        return 0;
      }
      const goNoGoTimeSeconds = this.timeToSeconds(eventData[genderKey]);
      console.log(`totalSeconds: ${totalSeconds} -> go: ${goNoGoTimeSeconds}`)
      if (totalSeconds <= goNoGoTimeSeconds && totalSeconds > 0) { // totalSeconds > 0 to avoid passing with 0:00
        return 60;
      }

      return 0; // Failed to meet standard or no time entered
    }

    // Update score untuk field tertentu
    updateScore(fieldName) {
      // Skip SPT karena tidak ada datanya
      if (fieldName === 'SPT') {
        return;
      }

      const gender = this.currentValues.gender;
      const age = this.currentValues.age;
      let points = 0;
      let statusText = '';

      switch (fieldName) {
        case 'MDL':
          points = this.calculateMDLPoints(this.currentValues.MDL, gender, age);
          break;
        case 'HRP':
          points = this.calculateHRPPoints(this.currentValues.HRP, gender, age);
          break;
        case 'SDC':
          const sdcSeconds = this.currentValues.SDC.min * 60 + this.currentValues.SDC.sec;
          points = this.calculateSDCPoints(sdcSeconds, gender, age);
          break;
        case 'PLK':
          const plkSeconds = this.currentValues.PLK.min * 60 + this.currentValues.PLK.sec;
          points = this.calculatePLKPoints(plkSeconds, gender, age);
          break;
        case '2MR':
          if (this.currentValues.useAlternateRun) {
            const altEventSeconds = this.currentValues['2MR'].min * 60 + this.currentValues['2MR'].sec;
            // Cek apakah selectedAlternateEvent ada dan memiliki dataset sebelum mengakses name
            if (this.currentValues.selectedAlternateEvent && this.currentValues.selectedAlternateEvent.dataset) {
              points = this.calculateAlternateRunPoints(altEventSeconds, gender, age, this.currentValues.selectedAlternateEvent.dataset.name);
              statusText = (points === 60) ? 'PASS' : 'FAIL'; // Set status for alternate
            } else {
              points = 0; // Tidak ada alternate event yang dipilih
              statusText = 'FAIL';
            }
            break;
          }

          const runSeconds = this.currentValues['2MR'].min * 60 + this.currentValues['2MR'].sec;
          points = this.calculate2MRPoints(runSeconds, gender, age);
          break;
      }

      this.scores[fieldName] = points;

      // Update tampilan points
      let pointsElement = document.querySelector(`[data-field-id="${fieldName}"] .form-field__points-value`);
      let statusElement;
      if (fieldName === '2MR' && this.currentValues.useAlternateRun) {
        // Update points and status for alternate event section
        pointsElement = document.querySelector('.alt-point');
        statusElement = document.querySelector('#alternateRunStatus');
        if (statusElement) {
          statusElement.textContent = statusText;
          statusElement.className = `form-field__status ${points === 60 ? 'status--pass' : 'status--fail'}`;
        }
      } else {
        // Update points for standard events
        pointsElement = document.querySelector(`[data-field-id="${fieldName}"] .form-field__points-value`);
      }

      if (pointsElement) {
        pointsElement.textContent = points;
      }

      console.log(`${fieldName} points updated: ${points}`);
    }

    // Update semua scores
    updateAllScores() {
      Object.keys(this.scores).forEach(fieldName => {
        this.updateScore(fieldName);
      });

      if (this.currentValues.useAlternateRun) {
        this.updateAlternateRunStandardDisplay();
      }
    }

    // Setup sliders dengan nilai valid saja
    setupSliders() {
      // Setup MDL slider dengan nilai valid
      this.setupValidValueSlider('MDL');
      // Setup HRP slider dengan nilai valid
      this.setupValidValueSlider('HRP');
      // Setup time-based sliders dengan nilai valid
      this.setupValidTimeSlider('SDC', false); // reverse untuk waktu
      this.setupValidTimeSlider('PLK', false);
      this.setupValidTimeSlider('2MR', false); // reverse untuk waktu

      this.setupSPTSlider();
    }

    // Setup slider dengan nilai valid saja (untuk MDL dan HRP)
    setupValidValueSlider(fieldName) {
      const sliderElement = document.querySelector(`[data-field-id="${fieldName}"] .slider`);
      const inputElement = document.querySelector(`input[name="${fieldName}"]`);
      
      if (!sliderElement || !window.noUiSlider) return;

      const gender = this.currentValues.gender;
      const ageGroup = this.getAgeGroupKey(this.currentValues.age);

      let data;
      switch (fieldName) {
        case 'MDL': data = this.data.mdl; break;
        case 'HRP': data = this.data.hrp; break;
        default: return;
      }

      // Determine field type
      const isHRP = fieldName === 'HRP';

      if (isHRP) {
        // ========== HRP SLIDER: Allow any input, use thresholds ==========
        // Get threshold values (requirements) from JSON
        const thresholdValues = this.getValidValuesForSlider(data, ageGroup, gender);
        
        // Remove duplicates and sort
        const seen = new Set();
        const uniqueThresholds = thresholdValues.filter(item => {
          const val = Number(item.value);
          if (seen.has(val) || isNaN(val)) return false;
          seen.add(val);
          return true;
        });
        uniqueThresholds.sort((a, b) => a.value - b.value);
        
        if (uniqueThresholds.length === 0) {
          console.warn(`HRP: No thresholds for ${ageGroup}/${gender}`);
          return;
        }

        const thresholdArray = uniqueThresholds.map(item => Number(item.value));
        const minThreshold = thresholdArray[0];
        const maxThreshold = thresholdArray[thresholdArray.length - 1];
        
        // Set slider range: exact min to max threshold (no buffer)
        const sliderMin = minThreshold;
        const sliderMax = maxThreshold;
        
        console.log(`HRP thresholds for ${ageGroup}/${gender}:`, thresholdArray, `Slider range: ${sliderMin}-${sliderMax}`);

        // Get current value
        const currentValue = Number(this.currentValues[fieldName]) || minThreshold;
        const startValue = Math.max(sliderMin, Math.min(sliderMax, currentValue));

        // Destroy old slider
        if (sliderElement.noUiSlider) {
          try {
            sliderElement.noUiSlider.destroy();
          } catch (error) {
            console.error(`Error destroying HRP slider:`, error);
          }
        }

        sliderElement.innerHTML = '';
        sliderElement.className = 'slider';

        // Create HRP slider - NO snapping, allow any value
        try {
          noUiSlider.create(sliderElement, {
            start: [startValue],
            connect: [true, false],
            range: {
              'min': sliderMin,
              'max': sliderMax
            },
            step: 1,
            direction: 'ltr',
            format: {
              to: function (value) {
                return Math.round(Number(value));
              },
              from: function (value) {
                return Number(value);
              }
            }
          });

          // Slider update: use exact slider value
          sliderElement.noUiSlider.on('update', (values) => {
            if (this.isUpdatingFromInput) return;
            
            const value = Math.round(parseFloat(values[0]));
            this.currentValues[fieldName] = value;
    this.currentValues.mdl_raw = value;

            const currentInput = document.querySelector(`input[name="${fieldName}"]`);
            if (currentInput) {
              currentInput.value = value;
            }

            this.updateScore(fieldName);
          });

          // Input change: use exact input value, update slider position
          const updateHRPInput = () => {
            const currentInput = document.querySelector(`input[name="${fieldName}"]`);
            if (!currentInput || !sliderElement.noUiSlider) return;
            
            // Allow empty input while typing
            if (currentInput.value === '' || currentInput.value === null) {
              return;
            }
            
            const inputValue = parseFloat(currentInput.value);
            if (isNaN(inputValue) || inputValue < 0) {
              // Invalid input, reset to min
              this.isUpdatingFromInput = true;
              sliderElement.noUiSlider.set(sliderMin);
              currentInput.value = sliderMin;
              this.currentValues[fieldName] = sliderMin;
              this.isUpdatingFromInput = false;
              this.updateScore(fieldName);
              return;
            }
            
            // Clamp value to slider range (min to max)
            const value = Math.max(sliderMin, Math.min(sliderMax, Math.round(inputValue)));
            this.currentValues[fieldName] = value;
            this.currentValues[fieldName] = value;

            // Update slider to show the value
            this.isUpdatingFromInput = true;
            sliderElement.noUiSlider.set(value);
            currentInput.value = value; // Clamped value
            this.isUpdatingFromInput = false;
            
            // Calculate points with clamped value
            this.updateScore(fieldName);
          };

          // Add input listener (only on change/blur, not on input to allow free typing)
          const currentInputElement = document.querySelector(`input[name="${fieldName}"]`);
          if (currentInputElement) {
            const newInput = currentInputElement.cloneNode(true);
            currentInputElement.parentNode.replaceChild(newInput, currentInputElement);
            
            const freshInputElement = document.querySelector(`input[name="${fieldName}"]`);
            if (freshInputElement) {
              freshInputElement.addEventListener('change', updateHRPInput);
              freshInputElement.addEventListener('blur', updateHRPInput); // Update when user clicks away
            }
          }

          console.log(`HRP slider created: range ${sliderMin}-${sliderMax}, start: ${startValue}`);
        } catch (error) {
          console.error(`Error creating HRP slider:`, error);
        }

      } else {
        // ========== MDL SLIDER: Allow any input, use exact match calculation ==========
        // Get valid values (exact match requirements) from JSON
        const validValues = this.getValidValuesForSlider(data, ageGroup, gender);
        
        // Remove duplicates and sort
        const seen = new Set();
        const uniqueValues = validValues.filter(item => {
          const val = Number(item.value);
          if (seen.has(val) || isNaN(val)) return false;
          seen.add(val);
          return true;
        });
        uniqueValues.sort((a, b) => a.value - b.value);
        
        if (uniqueValues.length === 0) {
          console.warn(`MDL: No valid values for ${ageGroup}/${gender}`);
          return;
        }

        const validValuesArray = uniqueValues.map(item => Number(item.value));
        const minValue = validValuesArray[0];
        const maxValue = validValuesArray[validValuesArray.length - 1];
        
        // Set slider range: exact min to max (no buffer)
        const sliderMin = minValue;
        const sliderMax = maxValue;
        
        console.log(`MDL valid values for ${ageGroup}/${gender}:`, validValuesArray, `Slider range: ${sliderMin}-${sliderMax}`);

        // Get current value
        const currentValue = Number(this.currentValues[fieldName]) || minValue;
        const startValue = Math.max(sliderMin, Math.min(sliderMax, currentValue));

        // Destroy old slider
        if (sliderElement.noUiSlider) {
          try {
            sliderElement.noUiSlider.destroy();
          } catch (error) {
            console.error(`Error destroying MDL slider:`, error);
          }
        }

        sliderElement.innerHTML = '';
        sliderElement.className = 'slider';

        // Create MDL slider - NO snapping, allow any value
        try {
          noUiSlider.create(sliderElement, {
            start: [startValue],
            connect: [true, false],
            range: {
              'min': sliderMin,
              'max': sliderMax
            },
            step: 1,
            direction: 'ltr',
            format: {
              to: function (value) {
                return Math.round(Number(value));
              },
              from: function (value) {
                return Number(value);
              }
            }
          });

          // MDL slider update: use exact slider value
          sliderElement.noUiSlider.on('update', (values) => {
            if (this.isUpdatingFromInput) return;
            
            const value = Math.round(parseFloat(values[0]));
            this.currentValues[fieldName] = value;

            const currentInput = document.querySelector(`input[name="${fieldName}"]`);
            if (currentInput) {
              currentInput.value = value;
            }

            this.updateScore(fieldName);
          });

          // MDL input change: use exact input value, update slider position
          const updateMDLInput = () => {
            const currentInput = document.querySelector(`input[name="${fieldName}"]`);
            if (!currentInput || !sliderElement.noUiSlider) return;
            
            // Allow empty input while typing
            if (currentInput.value === '' || currentInput.value === null) {
              return;
            }
            
            const inputValue = parseFloat(currentInput.value);
            if (isNaN(inputValue) || inputValue < 0) {
              // Invalid input, reset to min
              this.isUpdatingFromInput = true;
              sliderElement.noUiSlider.set(sliderMin);
              currentInput.value = sliderMin;
              this.currentValues[fieldName] = sliderMin;
              this.isUpdatingFromInput = false;
              this.updateScore(fieldName);
              return;
            }
            
            // Clamp value to slider range (min to max)
            const value = Math.max(sliderMin, Math.min(sliderMax, Math.round(inputValue)));
            this.currentValues[fieldName] = value;
            
            // Update slider to show the value
            this.isUpdatingFromInput = true;
            sliderElement.noUiSlider.set(value);
            currentInput.value = value; // Clamped value
            this.isUpdatingFromInput = false;
            
            // Calculate points with clamped value
            this.updateScore(fieldName);
          };

          // Add input listener (only on change/blur, not on input to allow free typing)
          const currentInputElement = document.querySelector(`input[name="${fieldName}"]`);
          if (currentInputElement) {
            const newInput = currentInputElement.cloneNode(true);
            currentInputElement.parentNode.replaceChild(newInput, currentInputElement);
            
            const freshInputElement = document.querySelector(`input[name="${fieldName}"]`);
            if (freshInputElement) {
              freshInputElement.addEventListener('change', updateMDLInput);
              freshInputElement.addEventListener('blur', updateMDLInput); // Update when user clicks away
            }
          }

          console.log(`MDL slider created: range ${sliderMin}-${sliderMax}, start: ${startValue}`);
        } catch (error) {
          console.error(`Error creating MDL slider:`, error);
        }
      }
    }

    // Setup slider waktu dengan nilai valid saja (SDC, PLK, 2MR)
    setupValidTimeSlider(fieldName, isReverse = false) {
      const sliderElement = document.querySelector(`[data-field-id="${fieldName}"] .slider`);
      const minInput = document.querySelector(`input[name="${fieldName}[min]"]`);
      const secInput = document.querySelector(`input[name="${fieldName}[sec]"]`);

      if (!sliderElement || !window.noUiSlider) return;

      const gender = this.currentValues.gender;
      const ageGroup = this.getAgeGroupKey(this.currentValues.age);

      let data;
      switch (fieldName) {
        case 'SDC': data = this.data.sdc; break;
        case 'PLK': data = this.data.plk; break;
        case '2MR': data = this.data.run; break;
        default: return;
      }

      // Get threshold values (requirements) from JSON
      const thresholdValues = this.getValidValuesForSlider(data, ageGroup, gender);

      if (thresholdValues.length === 0) {
        console.warn(`Time slider ${fieldName}: No thresholds for ${ageGroup}/${gender}`);
        return;
      }

      // Remove duplicates and sort
      const seen = new Set();
      const uniqueThresholds = thresholdValues.filter(item => {
        const val = Number(item.value);
        if (seen.has(val) || isNaN(val)) return false;
        seen.add(val);
        return true;
      });
      uniqueThresholds.sort((a, b) => a.value - b.value);

      const thresholdArray = uniqueThresholds.map(item => Number(item.value));
      const minThreshold = thresholdArray[0];
      const maxThreshold = thresholdArray[thresholdArray.length - 1];
      
      // Set slider range: exact min to max threshold (no buffer)
      const sliderMin = minThreshold;
      const sliderMax = maxThreshold;
      
      console.log(`Time slider ${fieldName} thresholds for ${ageGroup}/${gender}:`, thresholdArray, `Slider range: ${sliderMin}-${sliderMax}s`);

      // Get current value
      const currentTime = this.currentValues[fieldName] || { min: 0, sec: 0 };
      const currentSeconds = currentTime.min * 60 + currentTime.sec;
      const startValue = Math.max(sliderMin, Math.min(sliderMax, currentSeconds || sliderMin));

      // Destroy old slider
      if (sliderElement.noUiSlider) {
        try {
          sliderElement.noUiSlider.destroy();
        } catch (error) {
          console.error(`Error destroying time slider ${fieldName}:`, error);
        }
      }

      sliderElement.innerHTML = '';
      sliderElement.className = 'slider';

      // Create time slider - NO snapping, allow any value
      try {
        noUiSlider.create(sliderElement, {
          start: [startValue],
          connect: [true, false],
          range: {
            'min': sliderMin,
            'max': sliderMax
          },
          step: 1,
          direction: 'ltr',
          format: {
            to: function (value) {
              return Math.round(Number(value));
            },
            from: function (value) {
              return Number(value);
            }
          }
        });

        // Time slider update: use exact slider value
        sliderElement.noUiSlider.on('update', (values) => {
          if (this.isUpdatingFromInput) return;
          
          const totalSeconds = Math.round(parseFloat(values[0]));
          const minutes = Math.floor(totalSeconds / 60);
          const seconds = totalSeconds % 60;

          this.currentValues[fieldName] = { min: minutes, sec: seconds };

          const currentMinInput = document.querySelector(`input[name="${fieldName}[min]"]`);
          const currentSecInput = document.querySelector(`input[name="${fieldName}[sec]"]`);
          if (currentMinInput && currentSecInput) {
            currentMinInput.value = minutes;
            currentSecInput.value = seconds;
          }

          this.updateScore(fieldName);
        });

        // Time input change: use exact input value, update slider position
        const updateTimeInput = () => {
          const currentMinInput = document.querySelector(`input[name="${fieldName}[min]"]`);
          const currentSecInput = document.querySelector(`input[name="${fieldName}[sec]"]`);
          
          if (!currentMinInput || !currentSecInput || !sliderElement.noUiSlider) return;
          
          // Allow empty input while typing - only process if at least one field has a value
          if ((currentMinInput.value === '' || currentMinInput.value === null) && 
              (currentSecInput.value === '' || currentSecInput.value === null)) {
            return;
          }
          
          const minutes = parseInt(currentMinInput.value || 0);
          const seconds = parseInt(currentSecInput.value || 0);
          const totalSeconds = minutes * 60 + seconds;
          
          if (totalSeconds < 0) {
            // Invalid input, reset to min
            this.isUpdatingFromInput = true;
            sliderElement.noUiSlider.set(sliderMin);
            const minMins = Math.floor(sliderMin / 60);
            const minSecs = sliderMin % 60;
            currentMinInput.value = minMins;
            currentSecInput.value = minSecs;
            this.currentValues[fieldName] = { min: minMins, sec: minSecs };
            this.isUpdatingFromInput = false;
            this.updateScore(fieldName);
            return;
          }
          
          // Clamp total seconds to slider range (min to max)
          const clampedSeconds = Math.max(sliderMin, Math.min(sliderMax, totalSeconds));
          const clampedMinutes = Math.floor(clampedSeconds / 60);
          const clampedSecs = clampedSeconds % 60;
          
          this.currentValues[fieldName] = { min: clampedMinutes, sec: clampedSecs };
          
          // Update slider to show the clamped value
          this.isUpdatingFromInput = true;
          sliderElement.noUiSlider.set(clampedSeconds);
          // Update input fields with clamped values
          currentMinInput.value = clampedMinutes;
          currentSecInput.value = clampedSecs;
          this.isUpdatingFromInput = false;
          
          // Calculate points with clamped value
          this.updateScore(fieldName);
        };

        // Add input listeners (only on change/blur, not on input to allow free typing)
        if (minInput) {
          const newMinInput = minInput.cloneNode(true);
          minInput.parentNode.replaceChild(newMinInput, minInput);
          const freshMinInput = document.querySelector(`input[name="${fieldName}[min]"]`);
          if (freshMinInput) {
            freshMinInput.addEventListener('change', updateTimeInput);
            freshMinInput.addEventListener('blur', updateTimeInput); // Update when user clicks away
          }
        }

        if (secInput) {
          const newSecInput = secInput.cloneNode(true);
          secInput.parentNode.replaceChild(newSecInput, secInput);
          const freshSecInput = document.querySelector(`input[name="${fieldName}[sec]"]`);
          if (freshSecInput) {
            freshSecInput.addEventListener('change', updateTimeInput);
            freshSecInput.addEventListener('blur', updateTimeInput); // Update when user clicks away
          }
        }

        console.log(`Time slider ${fieldName} created: range ${sliderMin}-${sliderMax}s, start: ${startValue}s`);
      } catch (error) {
        console.error(`Error creating time slider ${fieldName}:`, error);
      }
    }

    setupSPTSlider() {
      // Setup SPT slider tapi tidak menghitung points
      const sliderElement = document.querySelector(`[data-field-id="SPT"] .slider`);
      const inputElement = document.querySelector(`input[name="SPT"]`);

      if (!sliderElement || !window.noUiSlider) return;

      // Hapus slider lama jika ada
      if (sliderElement.noUiSlider) {
        sliderElement.noUiSlider.destroy();
      }

      // Buat slider baru
      noUiSlider.create(sliderElement, {
        range: { min: 2.3, max: 13.1 },
        start: 2.3,
        step: 0.1,
        connect: 'lower',
        format: {
          to: value => parseFloat(value).toFixed(1),
          from: value => Number(value)
        }
      });

      // Event listener untuk slider
      sliderElement.noUiSlider.on('update', (values) => {
        const value = parseFloat(values[0]);
        this.currentValues.SPT = value;

        if (inputElement) {
          inputElement.value = value.toFixed(1);
        }

        // Set points ke 0 karena tidak ada data
        const pointsElement = document.querySelector(`[data-field-id="SPT"] .form-field__points-value`);
        if (pointsElement) {
          pointsElement.textContent = '0';
        }
      });

      // Event listener untuk input
      if (inputElement) {
        inputElement.addEventListener('change', () => {
          const value = parseFloat(inputElement.value) || 2.3;
          const clampedValue = Math.max(2.3, Math.min(13.1, value));
          inputElement.value = clampedValue.toFixed(1);
          sliderElement.noUiSlider.set(clampedValue);
        });
      }
    }

    // Setup event listeners
    setupEventListeners() {
      console.log('Setup Event Listener');
      const genderSelect = document.querySelector('select[name="gender"]');
      const ageSelect = document.querySelector('select[name="age"]');
      const alternateRunToggles = document.querySelectorAll('.toggle-event__option');

      if (genderSelect) {
        genderSelect.addEventListener('change', (e) => {
          this.currentValues.gender = e.target.value;
          this.setupSliders();
          this.updateAllScores();
        });
      }

      if (ageSelect) {
        ageSelect.addEventListener('change', (e) => {
          this.currentValues.age = e.target.value;
          this.setupSliders();

          if(this.currentValues.useAlternateRun) {
            this.updateAlternateRunStandardDisplay();
          }

          this.updateAllScores();
        });
      }

      // [Alternate Run Toggle Listener]
      alternateRunToggles.forEach(toggle => {
        toggle.addEventListener('click', (e) => { 
          if (!e.currentTarget.classList.contains('event-selected') && e.currentTarget.dataset.optionId == 'alt-event') {
            e.currentTarget.classList.add("event-selected");
            this.toggleAlternateRunInputs(true);
          } else {
            e.currentTarget.classList.add("event-selected");
            this.toggleAlternateRunInputs(false);
          }

          alternateRunToggles.forEach(otherToggle => {
            if (otherToggle !== e.currentTarget) otherToggle.classList.remove('event-selected');
          })
        });
      });

      // Listener entered input alt event
      const altInputs = document.querySelectorAll(".mmss-input");
      if (altInputs) {
        altInputs.forEach(el => {
          el.addEventListener('input', e => {
            const current = e.currentTarget;
            
            // Jika input ini berisi nilai (meskipun belum lengkap)
            if (current.value.trim() !== '') {
              // Langsung set sebagai selected alternate event
              this.currentValues.selectedAlternateEvent = current;
              
              // Disable dan clear input lain
              altInputs.forEach(other => {
                if (other !== current) {
                  other.disabled = true;
                  other.value = ''; // Clear nilai input lain
                }
              });
            } else {
              // Jika input dikosongkan, aktifkan semua input lain
              altInputs.forEach(other => {
                other.disabled = false;
              });
              
              // Cek apakah masih ada input lain yang berisi nilai
              const activeInput = Array.from(altInputs).find(input => 
                input !== current && input.value.trim() !== ''
              );
              
              if (activeInput) {
                // Set input lain yang masih berisi nilai sebagai selected
                this.currentValues.selectedAlternateEvent = activeInput;
              } else {
                // Tidak ada input yang berisi nilai, reset
                this.currentValues.selectedAlternateEvent = null;
                this.currentValues['2MR'] = { min: 0, sec: 0 };
              }
            }
            
            // Update display setelah selectedAlternateEvent diset
            this.updateAlternateRunStandardDisplay();

            // Jika input berisi format waktu yang valid, update nilai dan score
            if (current.value.includes(':')) {
              const [altMinutes, altSeconds] = current.value.split(':');
              const altMin = parseInt(altMinutes) || 0;
              const altSec = parseInt(altSeconds) || 0;
              this.currentValues['2MR'] = { min: altMin, sec: altSec };
            } else if (current.value.trim() === '') {
              // Jika input dikosongkan, reset waktu
              this.currentValues['2MR'] = { min: 0, sec: 0 };
            }
            
            // Selalu update score setelah perubahan
            this.updateScore('2MR');
            
            // Update progress bars jika result sedang ditampilkan
            const resultBlock = document.querySelector('.result');
            if (resultBlock && !resultBlock.classList.contains('result--hidden')) {
              this.updateProgressBars();
            }
          });
          
          // Tambahkan event listener untuk focus - untuk clear input lain ketika focus
          el.addEventListener('focus', e => {
            const current = e.currentTarget;
            
            // Jika ada input lain yang berisi nilai, clear mereka
            altInputs.forEach(other => {
              if (other !== current && other.value.trim() !== '') {
                other.value = '';
                other.disabled = false; // Enable dulu sebelum disable untuk menghindari konflik
                setTimeout(() => {
                  other.disabled = true;
                }, 0);
              }
            });
            
            // Set sebagai selected jika belum
            if (this.currentValues.selectedAlternateEvent !== current) {
              this.currentValues.selectedAlternateEvent = current;
              this.updateAlternateRunStandardDisplay();
              
              // Update progress bars jika result sedang ditampilkan
              const resultBlock = document.querySelector('.result');
              if (resultBlock && !resultBlock.classList.contains('result--hidden')) {
                this.updateProgressBars();
              }
            }
          });
        });
      }

      // Calculate button
      const calculateBtn = document.querySelector('.calc-button:not(.calc-button--light)');
      if (calculateBtn) {
        calculateBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.showResults();
        });
      }

      // Reset button
      const resetBtn = document.querySelector('.calc-button--light');
      if (resetBtn) {
        resetBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.resetForm();
        });
      }
    }

   // FIX #1: toggleAlternateRunInputs() - Properly clear 2MR data
toggleAlternateRunInputs(activateAlt) {
  const altElement = document.querySelector('[data-field-id="alternate-events"]');
  const twoMRElement = document.querySelector('[data-field-id="2MR"]');
  this.currentValues.useAlternateRun = activateAlt;

  if (activateAlt) {
    console.log("🔄 Activating Alternate Events - CLEARING 2MR DATA");
    
    // Hide 2MR section
    if (twoMRElement) twoMRElement.style.display = 'none';
    
    // Show alternate section
    if (altElement) altElement.style.display = 'block';
    
    // ✅ CLEAR 2MR INPUT FIELDS - BEFORE clearing Omni
    const twoMRMinInput = document.querySelector('input[name="2MR[min]"]');
    const twoMRSecInput = document.querySelector('input[name="2MR[sec]"]');
    
    if (twoMRMinInput) twoMRMinInput.value = '';
    if (twoMRSecInput) twoMRSecInput.value = '';
    
    // ✅ RESET currentValues['2MR'] to 0
    this.currentValues['2MR'] = { min: 0, sec: 0 };
    
    // ✅ UPDATE SCORE for 2MR (so it becomes 0)
    this.updateScore('2MR');
    
    // ✅ CLEAR 2MR from Omnisend FIELDS
    if (window.omniInputs?.twomr_score) {
      window.omniInputs.twomr_score.value = "";
      window.omniInputs.twomr_score.dispatchEvent(new Event("input", { bubbles: true }));
      window.omniInputs.twomr_score.dispatchEvent(new Event("change", { bubbles: true }));
    }
    if (window.omniInputs?.twomr_raw) {
      window.omniInputs.twomr_raw.value = "";
      window.omniInputs.twomr_raw.dispatchEvent(new Event("input", { bubbles: true }));
      window.omniInputs.twomr_raw.dispatchEvent(new Event("change", { bubbles: true }));
    }
    
    console.log("✅ 2MR Data Cleared:", this.currentValues['2MR']);
    
  } else {
    console.log("🔄 Deactivating Alternate Events - CLEARING ALT DATA");
    
    // Show 2MR section
    if (twoMRElement) twoMRElement.style.display = 'block';
    
    // Hide alternate section
    if (altElement) altElement.style.display = 'none';
    
    // ✅ CLEAR ALTERNATE EVENT INPUTS
    const altInputs = document.querySelectorAll(".mmss-input");
    altInputs.forEach(input => {
      input.value = "";
      input.disabled = false;
    });
    
    // ✅ RESET currentValues for alt event
    this.currentValues['2MR'] = { min: 0, sec: 0 };
    this.currentValues.selectedAlternateEvent = null;
    
    // ✅ UPDATE SCORE (so it becomes 0)
    this.updateScore('2MR');
    
    // ✅ CLEAR ALTERNATE from Omnisend FIELDS
    if (window.omniInputs?.altevent_score) {
      window.omniInputs.altevent_score.value = "";
      window.omniInputs.altevent_score.dispatchEvent(new Event("input", { bubbles: true }));
      window.omniInputs.altevent_score.dispatchEvent(new Event("change", { bubbles: true }));
    }
    if (window.omniInputs?.altevent_raw) {
      window.omniInputs.altevent_raw.value = "";
      window.omniInputs.altevent_raw.dispatchEvent(new Event("input", { bubbles: true }));
      window.omniInputs.altevent_raw.dispatchEvent(new Event("change", { bubbles: true }));
    }
    if (window.omniInputs?.altevent) {
      window.omniInputs.altevent.value = "";
      window.omniInputs.altevent.dispatchEvent(new Event("input", { bubbles: true }));
      window.omniInputs.altevent.dispatchEvent(new Event("change", { bubbles: true }));
    }
    
    console.log("✅ Alternate Event Data Cleared");
  }
}

resetForm() {
  // Reset values
  this.currentValues = {
    gender: 'combat',
    age: '17',
    MDL: 80,
    SPT: 2.3,
    HRP: 4,
    SDC: { min: 0, sec: 0 },
    PLK: { min: 0, sec: 0 },
    '2MR': { min: 0, sec: 0 }
  };
  this.currentValues.useAlternateRun = false;
  this.currentValues.selectedAlternateEvent = null;

  const altInputs = document.querySelectorAll(".mmss-input");
  altInputs.forEach(input => {
    input.value = "";
    input.disabled = false;
  });

  const altElement = document.querySelector('[data-field-id="alternate-events"]');
  const twoMRElement = document.querySelector('[data-field-id="2MR"]');

  if (altElement) altElement.style.display = "none";
  if (twoMRElement) twoMRElement.style.display = "block";

  document.querySelectorAll(".toggle-event__option")
    .forEach(toggle => toggle.classList.remove("event-selected"));

  const standardNote = document.querySelector("#alternateRunStandardNote");
  if (standardNote) standardNote.textContent = "";

  const status = document.querySelector("#alternateRunStatus");
  if (status) {
    status.textContent = "";
    status.className = "form-field__status";
  }

  // Reset selects
  const genderSelect = document.querySelector('select[name="gender"]');
  const ageSelect = document.querySelector('select[name="age"]');

  if (genderSelect) genderSelect.value = 'combat';
  if (ageSelect) ageSelect.value = '17';

  // CLEAR ALL OMNI FIELDS - individually
  if (window.omniInputs) {
    // 2-Mile fields
    if (window.omniInputs.twomr_score) window.omniInputs.twomr_score.value = "";
    if (window.omniInputs.twomr_raw) window.omniInputs.twomr_raw.value = "";
    
    // Alternate Event fields
    if (window.omniInputs.altevent_score) window.omniInputs.altevent_score.value = "";
    if (window.omniInputs.altevent_raw) window.omniInputs.altevent_raw.value = "";
    if (window.omniInputs.altevent) window.omniInputs.altevent.value = "";
    
    // Other event fields
    if (window.omniInputs.mdl_score) window.omniInputs.mdl_score.value = "";
    if (window.omniInputs.hrp_score) window.omniInputs.hrp_score.value = "";
    if (window.omniInputs.sdc_score) window.omniInputs.sdc_score.value = "";
    if (window.omniInputs.plk_score) window.omniInputs.plk_score.value = "";
    
    // Raw fields
    if (window.omniInputs.mdl_raw) window.omniInputs.mdl_raw.value = "";
    if (window.omniInputs.hrp_raw) window.omniInputs.hrp_raw.value = "";
    if (window.omniInputs.sdc_raw) window.omniInputs.sdc_raw.value = "";
    if (window.omniInputs.plk_raw) window.omniInputs.plk_raw.value = "";
    
    // Other fields
    if (window.omniInputs.total_points) window.omniInputs.total_points.value = "";
    if (window.omniInputs.aft_standard) window.omniInputs.aft_standard.value = "";
    if (window.omniInputs.age_group) window.omniInputs.age_group.value = "";
  }

  // Hide results
  const resultBlock = document.querySelector('.result');
  if (resultBlock) {
    resultBlock.classList.add('result--hidden');
  }

  // Rebuild sliders dengan nilai default
  this.setupSliders();

  // Update scores
  this.updateAllScores();

  // ===== CONSOLE DEBUG =====
  console.log("=== AFTER RESET - OMNI FIELDS DEBUG ===");
  console.log("twomr_score:", window.omniInputs?.twomr_score?.value);
  console.log("twomr_raw:", window.omniInputs?.twomr_raw?.value);
  console.log("altevent_score:", window.omniInputs?.altevent_score?.value);
  console.log("altevent_raw:", window.omniInputs?.altevent_raw?.value);
  console.log("altevent:", window.omniInputs?.altevent?.value);
  console.log("total_points:", window.omniInputs?.total_points?.value);
  console.log("======================================");
  console.log("✅ Form reset - ALL FIELDS CLEARED");
}

    updateAlternateRunStandardDisplay() {
      const standardNoteElement = document.querySelector('#alternateRunStandardNote');
      const genderKey = this.getGenderKey(this.currentValues.gender); // Output: M or F
      const ageKey = this.getAgeGroupKey(this.currentValues.age);
      const ageGroup = this.data.alternateRuns.find(e => e.age_group === ageKey);
      if (standardNoteElement && this.currentValues.selectedAlternateEvent && this.data.alternateRuns) {
      const eventData = ageGroup.exercises[this.currentValues.selectedAlternateEvent.dataset.name];
        if (eventData) {
          const standardTime = eventData[genderKey];
          standardNoteElement.textContent = `Go/No-Go Standard: ${standardTime}`;
          standardNoteElement.style.display = 'block';
        } else {
          standardNoteElement.textContent = `Standard not available!`
        }
      } else if (standardNoteElement) {
        standardNoteElement.textContent = ``;
      }
    }

    setupAlternateRunInputListeners(min, sec) {
      console.log(min, sec)
      this.currentValues['2MR'] = { min: min, sec: sec }
      console.log(this.currentValues['2MR']);
      this.updateScore('2MR');
    }

    showResults() {
      const totalScore = Object.values(this.scores).reduce((sum, score) => sum + score, 0);
      const maxScore = 500;
      const percentage = Math.round((totalScore / maxScore) * 100);
      // Update total score
      const scoreElement = document.querySelector('.total__score');
      const percentElement = document.querySelector('.total__percent');

      if (scoreElement) scoreElement.textContent = totalScore;
      if (percentElement) percentElement.textContent = percentage;

      const allEventsPassedMinimum = Object.values(this.scores).every(score => score >= 60);

      // Tentukan kategori hasil (60 points per event minimum untuk 5 events = 300)
      let category = 'FAILED';
      let categoryClass = 'category--failed';
      if (this.currentValues.gender == 'combat') {
        if (totalScore >= 350 && allEventsPassedMinimum) { // 60 points per event minimum untuk 5 events
          category = 'PASSED';
          categoryClass = 'category--passed';
        }
      } else {
        if (totalScore >= 300) {
          category = 'PASSED';
          categoryClass = 'category--passed';
        }
      }


      const categoryElement = document.querySelector('.result__cat-name');
      if (categoryElement) {
        categoryElement.textContent = category;
        categoryElement.className = `category total__row-value result__cat-name ${categoryClass}`;
      }
      this.updateOmniInputs();
      this.updateProgressBars();

      // Tampilkan result block
      const resultBlock = document.querySelector('.result');
      if (resultBlock) {
        resultBlock.classList.remove('result--hidden');

        setTimeout(() => {
          resultBlock.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        });
      }

      console.log(`Total Score: ${totalScore}/${maxScore} - ${category}`);
    }
   buildRawAndPointValues() {
    const raw = {};
    const pts = this.scores;

    // MDL
    raw.mdl_raw = this.currentValues.MDL ?? "";

    // HRP
    raw.hrp_raw = this.currentValues.HRP ?? "";

    // SDC → MM:SS
    if (this.currentValues.SDC) {
        const m = String(this.currentValues.SDC.min).padStart(2, "0");
        const s = String(this.currentValues.SDC.sec).padStart(2, "0");
        raw.sdc_raw = `${m}:${s}`;
    } else {
        raw.sdc_raw = "";
    }

    // PLK → MM:SS
    if (this.currentValues.PLK) {
        const m = String(this.currentValues.PLK.min).padStart(2, "0");
        const s = String(this.currentValues.PLK.sec).padStart(2, "0");
        raw.plk_raw = `${m}:${s}`;
    } else {
        raw.plk_raw = "";
    }

    // 2MR / ALT - useAlternateRun use karo
    if (this.currentValues.useAlternateRun) {
        const m = String(this.currentValues["2MR"].min).padStart(2, "0");
        const s = String(this.currentValues["2MR"].sec).padStart(2, "0");
        raw.altevent_raw = `${m}:${s}`;
        raw.twomr_raw = "";
    } else {
        const m = String(this.currentValues["2MR"].min).padStart(2, "0");
        const s = String(this.currentValues["2MR"].sec).padStart(2, "0");
        raw.twomr_raw = `${m}:${s}`;
        raw.altevent_raw = "";
    }

    const total_points = Object.values(this.scores).reduce((a, b) => a + b, 0);

    return { raw, pts, total_points };
}

buildRawAndPointValues() {
    const raw = {};
    const pts = this.scores;

    // MDL
    raw.mdl_raw = this.currentValues.MDL ?? "";

    // HRP
    raw.hrp_raw = this.currentValues.HRP ?? "";

    // SDC → MM:SS
    if (this.currentValues.SDC) {
        const m = String(this.currentValues.SDC.min).padStart(2, "0");
        const s = String(this.currentValues.SDC.sec).padStart(2, "0");
        raw.sdc_raw = `${m}:${s}`;
    } else {
        raw.sdc_raw = "";
    }

    // PLK → MM:SS
    if (this.currentValues.PLK) {
        const m = String(this.currentValues.PLK.min).padStart(2, "0");
        const s = String(this.currentValues.PLK.sec).padStart(2, "0");
        raw.plk_raw = `${m}:${s}`;
    } else {
        raw.plk_raw = "";
    }

    // 2MR / ALT - useAlternateRun use karo
    if (this.currentValues.useAlternateRun) {
        const m = String(this.currentValues["2MR"].min).padStart(2, "0");
        const s = String(this.currentValues["2MR"].sec).padStart(2, "0");
        raw.altevent_raw = `${m}:${s}`;
        raw.twomr_raw = "";
    } else {
        const m = String(this.currentValues["2MR"].min).padStart(2, "0");
        const s = String(this.currentValues["2MR"].sec).padStart(2, "0");
        raw.twomr_raw = `${m}:${s}`;
        raw.altevent_raw = "";
    }

    const total_points = Object.values(this.scores).reduce((a, b) => a + b, 0);

    return { raw, pts, total_points };
}

// FIX #2: updateOmniInputs() - Properly send ALTERNATE or 2MR data (NOT both)
// FIX #1: toggleAlternateRunInputs() - Properly clear 2MR data
toggleAlternateRunInputs(activateAlt) {
  const altElement = document.querySelector('[data-field-id="alternate-events"]');
  const twoMRElement = document.querySelector('[data-field-id="2MR"]');
  this.currentValues.useAlternateRun = activateAlt;

  if (activateAlt) {
    console.log("🔄 Activating Alternate Events - CLEARING 2MR DATA");
    
    // Hide 2MR section
    if (twoMRElement) twoMRElement.style.display = 'none';
    
    // Show alternate section
    if (altElement) altElement.style.display = 'block';
    
    // ✅ CLEAR 2MR INPUT FIELDS - BEFORE clearing Omni
    const twoMRMinInput = document.querySelector('input[name="2MR[min]"]');
    const twoMRSecInput = document.querySelector('input[name="2MR[sec]"]');
    
    if (twoMRMinInput) twoMRMinInput.value = '';
    if (twoMRSecInput) twoMRSecInput.value = '';
    
    // ✅ RESET currentValues['2MR'] to 0
    this.currentValues['2MR'] = { min: 0, sec: 0 };
    
    // ✅ UPDATE SCORE for 2MR (so it becomes 0)
    this.updateScore('2MR');
    
    // ✅ CLEAR 2MR from Omnisend FIELDS
    if (window.omniInputs?.twomr_score) {
      window.omniInputs.twomr_score.value = "";
      window.omniInputs.twomr_score.dispatchEvent(new Event("input", { bubbles: true }));
      window.omniInputs.twomr_score.dispatchEvent(new Event("change", { bubbles: true }));
    }
    if (window.omniInputs?.twomr_raw) {
      window.omniInputs.twomr_raw.value = "";
      window.omniInputs.twomr_raw.dispatchEvent(new Event("input", { bubbles: true }));
      window.omniInputs.twomr_raw.dispatchEvent(new Event("change", { bubbles: true }));
    }
    
    console.log("✅ 2MR Data Cleared:", this.currentValues['2MR']);
    
  } else {
    console.log("🔄 Deactivating Alternate Events - CLEARING ALT DATA");
    
    // Show 2MR section
    if (twoMRElement) twoMRElement.style.display = 'block';
    
    // Hide alternate section
    if (altElement) altElement.style.display = 'none';
    
    // ✅ CLEAR ALTERNATE EVENT INPUTS
    const altInputs = document.querySelectorAll(".mmss-input");
    altInputs.forEach(input => {
      input.value = "";
      input.disabled = false;
    });
    
    // ✅ RESET currentValues for alt event
    this.currentValues['2MR'] = { min: 0, sec: 0 };
    this.currentValues.selectedAlternateEvent = null;
    
    // ✅ UPDATE SCORE (so it becomes 0)
    this.updateScore('2MR');
    
    // ✅ CLEAR ALTERNATE from Omnisend FIELDS
    if (window.omniInputs?.altevent_score) {
      window.omniInputs.altevent_score.value = "";
      window.omniInputs.altevent_score.dispatchEvent(new Event("input", { bubbles: true }));
      window.omniInputs.altevent_score.dispatchEvent(new Event("change", { bubbles: true }));
    }
    if (window.omniInputs?.altevent_raw) {
      window.omniInputs.altevent_raw.value = "";
      window.omniInputs.altevent_raw.dispatchEvent(new Event("input", { bubbles: true }));
      window.omniInputs.altevent_raw.dispatchEvent(new Event("change", { bubbles: true }));
    }
    if (window.omniInputs?.altevent) {
      window.omniInputs.altevent.value = "";
      window.omniInputs.altevent.dispatchEvent(new Event("input", { bubbles: true }));
      window.omniInputs.altevent.dispatchEvent(new Event("change", { bubbles: true }));
    }
    
    console.log("✅ Alternate Event Data Cleared");
  }
}

// FIX #2: updateOmniInputs() - Properly send ALTERNATE or 2MR data (NOT both)
updateOmniInputs() {
  if (!window.omniInputs || !window.omniInputs.mdl_score) {
    console.log("⏳ Omnisend not ready yet...");
    setTimeout(() => this.updateOmniInputs(), 300);
    return;
  }

  const { raw, pts, total_points } = this.buildRawAndPointValues();
  const isAlt = this.currentValues.useAlternateRun;
  const ageGroup = this.getAgeGroupKey(this.currentValues.age);

  console.log("📊 DEBUG - isAlt:", isAlt);
  console.log("📊 DEBUG - selectedAlternateEvent:", this.currentValues.selectedAlternateEvent);
  console.log("📊 DEBUG - 2MR time:", `${this.currentValues['2MR'].min}:${this.currentValues['2MR'].sec}`);
  console.log("📊 DEBUG - 2MR points:", pts["2MR"]);

  const push = (field, value) => {
    if (!field) return;
    field.value = value ?? "";
    field.dispatchEvent(new Event("input", { bubbles: true }));
    field.dispatchEvent(new Event("change", { bubbles: true }));
  };

  // ===== STEP 1: SEND COMMON DATA (MDL, HRP, SDC, PLK) =====
  push(window.omniInputs.aft_standard, this.currentValues.gender);
  push(window.omniInputs.age_group, ageGroup);

  push(window.omniInputs.mdl_score, pts.MDL);
  push(window.omniInputs.hrp_score, pts.HRP);
  push(window.omniInputs.sdc_score, pts.SDC);
  push(window.omniInputs.plk_score, pts.PLK);

  push(window.omniInputs.mdl_raw, raw.mdl_raw || "");
  push(window.omniInputs.hrp_raw, raw.hrp_raw || "");
  push(window.omniInputs.sdc_raw, raw.sdc_raw || "");
  push(window.omniInputs.plk_raw, raw.plk_raw || "");

  // ===== STEP 2: BASED ON isAlt FLAG - SEND ALTERNATE EVENT OR 2MR =====
  if (isAlt) {
    console.log("✅ SENDING ALTERNATE EVENT DATA");

    // Get alternate event name
    const altEventName = this.currentValues.selectedAlternateEvent?.dataset?.name || "";
    console.log("🏃 Alternate Event Name:", altEventName);

    // SEND: Alternate Event Score
    push(window.omniInputs.altevent_score, pts["2MR"]);

    // SEND: Alternate Event Raw Time
    push(window.omniInputs.altevent_raw, raw.altevent_raw || "");

    // SEND: Alternate Event Name
    push(window.omniInputs.altevent, altEventName);

    // CLEAR: 2-Mile Run data (SET EMPTY)
    push(window.omniInputs.twomr_score, "");
    push(window.omniInputs.twomr_raw, "");

    console.log("📤 Alternate Event Sent:", {
      altevent_score: pts["2MR"],
      altevent_raw: raw.altevent_raw,
      altevent: altEventName
    });

  } else {
    console.log("✅ SENDING 2-MILE RUN DATA");

    // SEND: 2-Mile Run Score
    push(window.omniInputs.twomr_score, pts["2MR"]);

    // SEND: 2-Mile Run Raw Time
    push(window.omniInputs.twomr_raw, raw.twomr_raw || "");

    // CLEAR: Alternate Event data (SET EMPTY)
    push(window.omniInputs.altevent_score, "");
    push(window.omniInputs.altevent_raw, "");
    push(window.omniInputs.altevent, "");

    console.log("📤 2-Mile Run Sent:", {
      twomr_score: pts["2MR"],
      twomr_raw: raw.twomr_raw
    });
  }

  // ===== STEP 3: ALWAYS SEND TOTAL POINTS =====
  push(window.omniInputs.total_points, total_points);

  // SEND: Scorecard Link
  push(
    window.omniInputs.scorecard_link,
    "https://www.grittysoldier.com/pages/army-fitness-test-aft-scorecard-da-form-705-test"
  );

  // ===== STEP 4: SEND isAlt FLAG (if field exists in Omnisend form) =====
  if (window.omniInputs?.is_alt_event) {
    push(window.omniInputs.is_alt_event, isAlt ? "true" : "false");
    console.log("🚩 is_alt_event flag sent:", isAlt ? "true" : "false");
  }

  // ===== DEBUG: Print Final State =====
  console.log("=== ✅ OMNISEND FIELDS FINAL STATE ===");
  console.log("twomr_score:", window.omniInputs.twomr_score?.value);
  console.log("twomr_raw:", window.omniInputs.twomr_raw?.value);
  console.log("altevent_score:", window.omniInputs.altevent_score?.value);
  console.log("altevent_raw:", window.omniInputs.altevent_raw?.value);
  console.log("altevent (name):", window.omniInputs.altevent?.value);
  console.log("total_points:", window.omniInputs.total_points?.value);
  console.log("is_alt_event:", window.omniInputs.is_alt_event?.value);
  console.log("=====================================");
}


    
    // Update progress bars
    updateProgressBars() {
      console.log("Update progress bar...")
      Object.keys(this.scores).forEach(fieldName => {
        const score = this.scores[fieldName];
        console.log(`Score untuk: ${fieldName}`);
        const percentage = Math.min(score, 100);

        const fieldBars = document.querySelectorAll('.field-bar');
        fieldBars.forEach((bar, index) => {
          // Gunakan indeks atau cara lain yang lebih reliable
          const titleElement = bar.querySelector('.field-bar__title');
          if (!titleElement) return;
          
          // Simpan original title sebagai data attribute jika belum ada
          if (!titleElement.dataset.originalTitle) {
            titleElement.dataset.originalTitle = titleElement.textContent.trim();
          }
          
          const originalTitle = titleElement.dataset.originalTitle;
          
          if (originalTitle === fieldName) {
            // Update title berdasarkan kondisi
            if (this.currentValues.useAlternateRun && originalTitle === "2MR") {
              if (this.currentValues.selectedAlternateEvent && this.currentValues.selectedAlternateEvent.dataset) {
                titleElement.innerHTML = `Alternate Event: <br>${this.currentValues.selectedAlternateEvent.dataset.name}`;
              } else {
                titleElement.innerHTML = `Alternate Event: <br>Not Selected`;
              }
            } else {
              // Restore original title untuk event lain
              titleElement.textContent = originalTitle;
            }
            
            const progress = bar.querySelector('.bar__progress');
            const label = bar.querySelector('.bar__label');
            const category = bar.querySelector('.field-bar__cat');

            if (progress) {
              progress.style.width = `${percentage}%`;
            }

            if (label) {
              label.textContent = `${score} points`;
            }

            if (category) {
              if (score >= 60) {
                category.textContent = 'PASS';
                category.className = 'category field-bar__cat category--passed';
              } else {
                category.textContent = 'FAIL';
                category.className = 'category field-bar__cat category--failed';
              }
            }
          }
        });
      });

      // Set SPT progress bar ke 0
      const fieldBars = document.querySelectorAll('.field-bar');
      fieldBars.forEach(bar => {
        const titleElement = bar.querySelector('.field-bar__title');
        if (!titleElement) return;
        
        const originalTitle = titleElement.dataset.originalTitle || titleElement.textContent.trim();
        
        if (originalTitle === 'SPT') {
          const progress = bar.querySelector('.bar__progress');
          const label = bar.querySelector('.bar__label');
          const category = bar.querySelector('.field-bar__cat');

          if (progress) progress.style.width = '0%';
          if (label) label.textContent = '0 points (No Data)';
          if (category) {
            category.textContent = 'N/A';
            category.className = 'category field-bar__cat';
          }
        }
      });
    }
    // Reset form
    resetForm() {
  // Reset values
  this.currentValues = {
    gender: 'combat',
    age: '17',
    MDL: 80,
    SPT: 2.3,
    HRP: 4,
    SDC: { min: 0, sec: 0 },
    PLK: { min: 0, sec: 0 },
    '2MR': { min: 0, sec: 0 }
  };
  this.currentValues.useAlternateRun = false;
  this.currentValues.selectedAlternateEvent = null;

  const altInputs = document.querySelectorAll(".mmss-input");
  altInputs.forEach(input => {
    input.value = "";
    input.disabled = false;
  });

  const altElement = document.querySelector('[data-field-id="alternate-events"]');
  const twoMRElement = document.querySelector('[data-field-id="2MR"]');

  if (altElement) altElement.style.display = "none";
  if (twoMRElement) twoMRElement.style.display = "block";

  document.querySelectorAll(".toggle-event__option")
    .forEach(toggle => toggle.classList.remove("event-selected"));

  const standardNote = document.querySelector("#alternateRunStandardNote");
  if (standardNote) standardNote.textContent = "";

  const status = document.querySelector("#alternateRunStatus");
  if (status) {
    status.textContent = "";
    status.className = "form-field__status";
  }

  // Reset selects
  const genderSelect = document.querySelector('select[name="gender"]');
  const ageSelect = document.querySelector('select[name="age"]');

  if (genderSelect) genderSelect.value = 'combat';
  if (ageSelect) ageSelect.value = '17';

  // CLEAR OMNI FIELDS - sab ko reset kar
  if (window.omniInputs) {
    const omniFieldsToReset = [
      'altevent_score',
      'altevent_raw',
      'altevent',
      'twomr_score',
      'twomr_raw',
      'mdl_score',
      'hrp_score',
      'sdc_score',
      'plk_score',
      'mdl_raw',
      'hrp_raw',
      'sdc_raw',
      'plk_raw',
      'total_points',
      'aft_standard',
      'age_group'
    ];

    omniFieldsToReset.forEach(fieldName => {
      if (window.omniInputs[fieldName]) {
        window.omniInputs[fieldName].value = "";
        window.omniInputs[fieldName].dispatchEvent(new Event("input", { bubbles: true }));
        window.omniInputs[fieldName].dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

  // Hide results
  const resultBlock = document.querySelector('.result');
  if (resultBlock) {
    resultBlock.classList.add('result--hidden');
  }

  // Rebuild sliders dengan nilai default
  this.setupSliders();

  // Update scores
  this.updateAllScores();

  console.log('Form reset - ALL OMNI FIELDS CLEARED');
    }
  }

  // Inisialisasi calculator ketika window load
  window.addEventListener('load', () => {
    // Code for time input Alt--Events!!
    const timeInputs = document.querySelectorAll('.mmss-input');
    const timeError = document.getElementById('timeInputError');

    timeInputs.forEach(input => {
      input.addEventListener('input', function() {
        let value = this.value.replace(/[^0-9]/g, '');
        if (value.length > 4) value = value.slice(0, 4);

        if (value.length <= 2) {
          this.value = value;
        } else {
          this.value = value.slice(0, value.length - 2) + ':' + value.slice(-2);
        }
      });

      input.addEventListener('blur', function() {
        const value = this.value.trim();
        timeError.textContent = '';

        if (value === "") return;

        const parts = value.split(':');
        if (parts.length !== 2) {
          timeError.textContent = `Wrong time format ${this.name}. use MM:SS.`;
          return;
        }

        const [minutesStr, secondsStr] = parts;
        if (!/^\d{1,2}$/.test(minutesStr) || !/^\d{1,2}$/.test(secondsStr)) {
          timeError.textContent = `Wrong time format ${this.name}. use MM:SS.`;
          return;
        }

        const minutes = parseInt(minutesStr, 10);
        const seconds = parseInt(secondsStr, 10);
        if (minutes < 0 || minutes > 59 || seconds < 0 || seconds > 59) {
          timeError.textContent = `Invalid time ${this.name}. use example: 00–59.`;
          return;
        }

        this.value = String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
      });
    });

    // Delay untuk memastikan semua library sudah dimuat
    setTimeout(() => {
      window.acftCalculator = new ACFTCalculator();
    }, 500); console.log("Loaded!")
  });


